import React from 'react';
import ReportGroup from '../ReportGroup';

export const ViewGroup = ({
  report_group_id,
  exit,
  error,
  savedReportsApi,
}) => {
  return (
    <div className="d-flex" id="wrapper" style={{ flex: 1 }}>
      <div id="page-content-wrapper">
        <ReportGroup
          _id={report_group_id}
          exit={exit}
          viewError={error}
          savedReportsApi={savedReportsApi}
        />
      </div>
    </div>
  );
};
